import {Component, inject, input, ChangeDetectionStrategy} from '@angular/core';
import {ApiService} from '../../../_services/api.service';
import {FormDetail} from '../../file-online-v2/models/api/Form';
import {PdfUrlRowComponent} from '../../../_shared/pdf-url-row/pdf-url-row.component';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import event = google.maps.event;
import {SiteConfigService} from '../../../_services/site-config.service';

@Component({
    selector: 'app-form-list-row',
    imports: [
        PdfUrlRowComponent,
        NgbTooltip
    ],
    templateUrl: './form-list-row.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-list-row.component.scss'
})
export class FormListRowComponent {

  protected siteConfigService = inject(SiteConfigService);
  formEntry = input.required<FormDetail>();

  constructor(protected apiService: ApiService) {
  }

  handleEFilePreClick(event: MouseEvent): void {
    if (this.formEntry().eFileMaintenance || this.siteConfigService.isEFileDisabled()) {
      event.preventDefault();
    }
  }
}
